import React from 'react';
import SideBarMenuItem from './SideBarMenuItem';

const SideBarMenu = ({ searchQuery = '' }) => {
    const raw_permissions = localStorage.getItem('permissions');
    const permissions_from_localstorage = raw_permissions || '';
    
    // If permissions array in localStorage is missing/empty, grant superadmin access to avoid blank menu
    const isSuperAdmin = !raw_permissions || permissions_from_localstorage.includes('master_menu') || permissions_from_localstorage.includes('view_dashboard');

    const hasPermission = (perm) => isSuperAdmin || permissions_from_localstorage.includes(perm);

    const matchesQuery = (name) => {
        if (!searchQuery) return true;
        return name.toLowerCase().includes(searchQuery.toLowerCase());
    };

    const hasVisibleOperations =
        (hasPermission('view_dashboard') && matchesQuery('Dashboard')) ||
        (hasPermission('view_dashboard') && matchesQuery('Customer Bookings')) ||
        (hasPermission('view_assigned_work_order') && matchesQuery('Assigned Jobs'));

    const hasVisiblePartners =
        matchesQuery('Service Partners') ||
        matchesQuery('Vendor Subscriptions') ||
        matchesQuery('Doorstep & Fee Rules') ||
        matchesQuery('Pricing Settings');

    const hasVisibleMarketplace =
        matchesQuery('Product Catalog') ||
        matchesQuery('Products') ||
        matchesQuery('Customer Orders') ||
        matchesQuery('Orders') ||
        matchesQuery('Invoices & Billing') ||
        matchesQuery('Bills');

    const hasVisibleQuality =
        matchesQuery('Customer Reviews') ||
        matchesQuery('Reviews');

    const hasVisibleMaster =
        matchesQuery('Service Definitions') ||
        (hasPermission('view_utility') && matchesQuery('Service Levels')) ||
        (hasPermission('view_work_order_statuses') && matchesQuery('Work Order Statuses'));

    const hasVisibleAdmin =
        (hasPermission('view_users') && matchesQuery('Users & Staff')) ||
        (hasPermission('view_customers') && matchesQuery('Customers')) ||
        (hasPermission('master_menu') && matchesQuery('Roles & Access')) ||
        matchesQuery('My Profile');

    const totalVisible =
        (hasVisibleOperations ? 1 : 0) +
        (hasVisiblePartners ? 1 : 0) +
        (hasVisibleMarketplace ? 1 : 0) +
        (hasVisibleQuality ? 1 : 0) +
        (hasVisibleMaster ? 1 : 0) +
        (hasVisibleAdmin ? 1 : 0);

    return (
        <ul className="ddwoms-nav">
            {/* Section 1: Operations & Bookings */}
            {hasVisibleOperations && (
                <>
                    <li className="ddwoms-nav-section-title">Operations &amp; Bookings</li>
                    {hasPermission('view_dashboard') && matchesQuery('Dashboard') &&
                        <SideBarMenuItem name="Dashboard" icon="fa-solid fa-chart-pie" routeName="/dashboard" />}
                    {hasPermission('view_dashboard') && matchesQuery('Customer Bookings') &&
                        <SideBarMenuItem name="Customer Bookings" icon="fa-solid fa-list-check" routeName="/requests" />}
                    {hasPermission('view_assigned_work_order') && matchesQuery('Assigned Jobs') &&
                        <SideBarMenuItem name="Assigned Jobs" icon="fa-solid fa-user-gear" routeName="/assignedworkorders" />}
                </>
            )}

            {/* Section 2: Partner & Field Network */}
            {hasVisiblePartners && (
                <>
                    <li className="ddwoms-nav-section-title">Partner &amp; Field Network</li>
                    {matchesQuery('Service Partners') &&
                        <SideBarMenuItem name="Service Partners" icon="fa-solid fa-store" routeName="/vendor/select" />}
                    {matchesQuery('Vendor Subscriptions') &&
                        <SideBarMenuItem name="Vendor Subscriptions" icon="fa-solid fa-crown" routeName="/vendor-subscriptions" />}
                    {(matchesQuery('Doorstep & Fee Rules') || matchesQuery('Pricing Settings')) &&
                        <SideBarMenuItem name="Doorstep &amp; Fee Rules" icon="fa-solid fa-calculator" routeName="/vendor-pricing-settings" />}
                </>
            )}

            {/* Section 3: Marketplace & Billing */}
            {hasVisibleMarketplace && (
                <>
                    <li className="ddwoms-nav-section-title">Marketplace &amp; Billing</li>
                    {(matchesQuery('Product Catalog') || matchesQuery('Products')) &&
                        <SideBarMenuItem name="Product Catalog" icon="fa-solid fa-box-open" routeName="/admin-products" />}
                    {(matchesQuery('Customer Orders') || matchesQuery('Orders')) &&
                        <SideBarMenuItem name="Customer Orders" icon="fa-solid fa-bag-shopping" routeName="/admin-orders" />}
                    {(matchesQuery('Invoices & Billing') || matchesQuery('Bills')) &&
                        <SideBarMenuItem name="Invoices &amp; Billing" icon="fa-solid fa-file-invoice-dollar" routeName="/admin-bills" />}
                </>
            )}

            {/* Section 4: Quality & Feedback */}
            {hasVisibleQuality && (
                <>
                    <li className="ddwoms-nav-section-title">Quality &amp; Feedback</li>
                    {(matchesQuery('Customer Reviews') || matchesQuery('Reviews')) &&
                        <SideBarMenuItem name="Customer Reviews" icon="fa-solid fa-star" routeName="/admin-reviews" />}
                </>
            )}

            {/* Section 5: Service Master Catalog */}
            {hasVisibleMaster && (
                <>
                    <li className="ddwoms-nav-section-title">Service Master Catalog</li>
                    {matchesQuery('Service Definitions') &&
                        <SideBarMenuItem name="Service Definitions" icon="fa-solid fa-layer-group" routeName="/service-definitions" />}
                    {hasPermission('view_utility') && matchesQuery('Service Levels') &&
                        <SideBarMenuItem name="Service Levels" icon="fa-solid fa-diagram-project" routeName="/service-request-services" />}
                    {hasPermission('view_work_order_statuses') && matchesQuery('Work Order Statuses') &&
                        <SideBarMenuItem name="Work Order Statuses" icon="fa-solid fa-sliders" routeName="/workorderstatuses" />}
                </>
            )}

            {/* Section 6: Administration & Access */}
            {hasVisibleAdmin && (
                <>
                    <li className="ddwoms-nav-section-title">Administration &amp; Staff</li>
                    {hasPermission('view_users') && matchesQuery('Users & Staff') &&
                        <SideBarMenuItem name="Users &amp; Staff" icon="fa-solid fa-users" routeName="/users" />}
                    {hasPermission('view_customers') && matchesQuery('Customers') &&
                        <SideBarMenuItem name="Customers" icon="fa-solid fa-address-book" routeName="/customers" />}
                    {hasPermission('master_menu') && matchesQuery('Roles & Access') &&
                        <SideBarMenuItem name="Roles &amp; Access" icon="fa-solid fa-shield-halved" routeName="/roles" />}
                    {matchesQuery('My Profile') &&
                        <SideBarMenuItem name="My Profile" icon="fa-solid fa-user-gear" routeName="/profile" />}
                </>
            )}

            {totalVisible === 0 && searchQuery && (
                <li className="ddwoms-nav-no-results">
                    <i className="fa-solid fa-magnifying-glass-minus" />
                    <span>No navigation items match &quot;{searchQuery}&quot;</span>
                </li>
            )}
        </ul>
    );
};

export default SideBarMenu;
